
theme.RecentlyViewed = (function () {
  var selectors = {
  }

  var init = false

  function RecentlyViewed(container) {
    this.container = container
    this.sectionId = this.container.getAttribute('data-section-id')
    this.namespace = '.recently-viewed' + this.sectionId
    theme.initWhenVisible({
      element: this.container,
      callback: this.init.bind(this),
      threshold: 600,
    })
  }

  RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
    init: function () {
      if (init) {
        return
      }
      this.recentlyClass = '.recently-viewed-products'

      init = true
      if (
        theme.recentlyViewed.recent.viewed.length === 0 &&
        theme.recentlyViewed.recent.constructor === Object
      ) {

        if (window.location.pathname.startsWith('/pages/welcome-back')) {
          return $(this.recentlyClass).closest('.shopify-section').hide()
          // .closest('.page-section').css({ paddingTop: 0 });
        }

        // No previous history on page load, so bail
        return
      }

      if (window.location.pathname.startsWith('/pages/welcome-back')) {
        $(this.recentlyClass).closest('.page-section')[0].style = {}
        $(this.recentlyClass).closest('.page-section').find('.vego-tab-title').removeClass('hide')
      }


      this.outputContainer = document.getElementById(
        'RecentlyViewed-' + this.sectionId
      )
      this.handle = this.container.getAttribute('data-product-handle')
      this.count = parseInt(this.container.getAttribute('data-recent-count'))

      // Request new product info via JS API
      var promises = [], that = this;
      let num = 0;
      theme.recentlyViewed.recent.viewed.forEach(
        function (handle) {
          if (handle !== 'undefined' && handle !== 'test-product') {
            if (num > that.count) return;
            num++;
            //memorial-day recently view
            if (window.location.pathname.startsWith('/pages/welcome-back')) {
              promises.push(this.getProductInfoInMemorialDayaPage(handle))
            } else {
              promises.push(this.getProductInfo(handle))
            }
          }
        }.bind(this)
      )

      Promise.all(promises).then(
        function (result) {
          //memorial-day recently view
          if (window.location.pathname === ('/pages/welcome-back')) {

            if (result.length === 0) {
              // no result data
              $(this.recentlyClass).closest('.vego-tab-content').hide()
                .closest('.page-section').css({ paddingTop: 0 });
              return;
            }
            $(window).resize(() => {
              try {
                if ($(this.recentlyClass).find('.slick-list').length) {
                  setTimeout(() => {
                    $(this.recentlyClass).slick('unslick');
                    this.renderRecentlyViewed(result)
                  }, 500)
                } else {
                  this.renderRecentlyViewed(result)
                }
              } catch (error) {
                console.log(error);
              }

            })
            this.renderRecentlyViewed(result)


          } else {
            if (!theme.templates['template-recent'].result) {
              theme.loadTemplate('template-recent').then(res => {
                theme.templates['template-recent'].result = res
                this.setupOutput(result)
                this.captureProductDetails(result)
              })
            } else {
              this.setupOutput(result)
              this.captureProductDetails(result)
            }
          }
        }.bind(this)
      )
    },
    pureStyle(index, $item) {
      const recentlyClass = '.recently-viewed-products'
      if (index === 0) {
        $item.find('style').insertBefore(recentlyClass)
      } else {
        $item.find('style').remove()
      }
    },
    renderRecentlyViewed: function (result) {
      const recentlyClass = this.recentlyClass;
      if ($(recentlyClass).length) {
        $(recentlyClass).html('')
        $(recentlyClass).addClass('grid grid-collection grid-product__group')
        if (theme.isMobile()) {
          Array.from(({ length: Math.ceil(result.length / 2) })).map((item, index) => index).forEach(index => {
            let $item = $(result[index]);
            this.pureStyle(index, $item)
            let $div = $('<div></div>');
            $div.css({ 'margin': '0 10px' });
            $item.find('.grid__item').css({ 'width': '100%', padding: 0 })

            $div.append($item.html())
            if (result[index + 1]) {
              let $oddItem = $(result[index + 1]);
              this.pureStyle(index + 1, $item)
              $oddItem.find('.grid__item').css({ 'width': '100%', padding: 0 })
              $div.append($oddItem.html())
            }
            $(recentlyClass).append($div)
          })

        } else {

          result.map((item, index) => {
            let $item = $(item);
            this.pureStyle(index, $item)
            $(recentlyClass).append($item.html())
          })
        }
        try {
          $(recentlyClass)
            .slick(Object.assign({}, {
              arrows: true,
              dots: true,
              slidesToShow: 4,
              slidesToScroll: 4,
              prevArrow: '<button type="button" class="slick-prev" role="button"><span class="sr-only">previous</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 2L2.5 11L11.5 20" stroke="black" stroke-width="3"/></svg></button>',
              nextArrow: '<button type="button" class="slick-next" role="button"><span class="sr-only">next</span><svg width="9" height="18" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51465 19.9971L10.5146 10.9971L1.51465 1.99707" stroke="black" stroke-width="3"/></svg></button>',
              draggable: false,
            }, theme.isMobile() ? {
              slidesToShow: 2,
              slidesToScroll: 2,

            } : {})).css('overflow', 'initial').on('afterChange', function() { AOS.refreshHard() })

        } catch (e) {
          console.log(e)
        }
        if (theme.settings.cartType === 'drawer') {
          try {
            $.$$updateInput()
            $(`${recentlyClass} select.grid-product-variant-input:enabled`).vselect()
            $(`${recentlyClass} [data-ui="select"]`).vselect()
            $('[data-toggle="tooltip"]').tooltip()
          } catch (e) {
            console.log(e)
          }
          $(`${recentlyClass} .grid-product`).collecionProduct()
        }
      }
    },
    getProductInfoInMemorialDayaPage: function (handle) {

      const recentlyViewedSection = `recently-viewed-product`;

      return new Promise(function (resolve, reject) {

        $.get(
          `${window.route_prefix}products/${handle}?sections=${recentlyViewedSection}`,
          function (data) {
            resolve(data[recentlyViewedSection]);
          }
        );

      })
    },

    getProductInfo: function (handle) {
      return new Promise(function (resolve, reject) {
        if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
          resolve(theme.recentlyViewed.productInfo[handle])
        } else {
          fetch(`${window.route_prefix}products/` + handle + ".js")
            .then(function (response) {
              return response.text();
            })
            .then(function (product) {
              resolve(product);
            });
        }
      })
    },

    setupOutput: function (products) {
      var allProducts = []
      var data = {}
      var limit = this.container.getAttribute('data-recent-count')
      var i = 0
      products.forEach(
        function (p) {
          if (!p) return
          var product = JSON.parse(p)
          // Ignore current product
          if (product.handle === this.handle) {
            return
          }
          // Ignore undefined key
          if (typeof product.handle == 'undefined') {
            return
          }
          i++
          // New or formatted properties
          product.url_formatted = theme.recentlyViewed.recent.products[product.handle]
            ? theme.recentlyViewed.recent.products[product.handle].url
            : product.url
          product.image_responsive_url = theme.Images.srcSetImages(product.featured_image)
          product.image_aspect_ratio =
            theme.recentlyViewed.recent.products[product.handle].aspectRatio
          let p_compare_at_price = product.compare_at_price;
            var firstVariant = product.variants[0]
          if (location.pathname.indexOf('/en-ca')>-1){
            if (!!theme.config.discountInfo[firstVariant.id].caCompareAtPrice)
              p_compare_at_price = theme.config.discountInfo[firstVariant.id].caCompareAtPrice;
          }else if (location.pathname.indexOf('/en-au')>-1){
            if (!!theme.config.discountInfo[firstVariant.id]?.auCompareAtPrice)
              p_compare_at_price =
                theme.config.discountInfo[firstVariant.id].auCompareAtPrice;
          }
            product.on_sale = p_compare_at_price > product.price;
          product.sold_out = !product.available

          product.price_formatted = theme.Currency.formatMoney(
            product.price,
            theme.settings.moneyFormat
          )
          product.compare_at_price_formatted = theme.Currency.formatMoney(
            p_compare_at_price,
            theme.settings.moneyFormat
          );
          product.price_min_formatted = theme.Currency.formatMoney(
            product.price_min,
            theme.settings.moneyFormat
          )
          product.money_saved = theme.Currency.formatMoney(
            p_compare_at_price - product.price,
            theme.settings.moneyFormat
          );
          if (product.tags.indexOf('Notify Me') > -1) {
            product.notify = true
          }

          // Unit pricing checks first variant
        
          // debugger;
          if (theme.config.discountInfo && theme.config.discountInfo[firstVariant.id]) {
            var discount = theme.config.discountInfo[firstVariant.id]
            if (discount.discounted && p_compare_at_price > product.price) {
              var savedAmount = p_compare_at_price - product.price;
              var savedPercent = Math.round(
                ((p_compare_at_price - product.price) * 100) /
                  p_compare_at_price
              );
              var discountText = "";
              if (discount.percent || savedPercent >= savedAmount / 100) {
                discountText = savedPercent + "% OFF";
              } else {
                discountText =
                  "SAVE " +
                  theme.Currency.formatMoney(
                    savedAmount,
                    "${{amount_no_decimals}}"
                  );
              }
              product.discountText = discountText;
            }
          }
          // if (firstVariant && firstVariant.unit_price) {
          //   var baseUnit = ''

          allProducts.push(product)
        }.bind(this)
      )

      data = {
        items: allProducts.slice(0, limit),
        grid_item_width: this.container.getAttribute('data-grid-item-class'),
      }

      if (allProducts.length === 0) {
        return
      }

      this.outputContainer.innerHTML = theme.templates['template-recent'].result(data)
      window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.initWidgets()

      if (AOS) {
        AOS.refreshHard()
      }
    },

    captureProductDetails: function (products) {
      for (var i = 0; i < products.length; i++) {
        var product = products[i]
        theme.recentlyViewed.productInfo[product.handle] = product
      }

      // Add data to session storage to reduce API requests later
      if (theme.config.hasSessionStorage) {
        sessionStorage.setItem(
          'recent-products',
          JSON.stringify(theme.recentlyViewed.productInfo)
        )
      }
    },

    onUnload: function () {
      init = false
    },
  })

  return RecentlyViewed
})()


theme.recentlyViewed.productInfo =
  theme.config.hasSessionStorage && sessionStorage['recent-products']
    ? JSON.parse(sessionStorage['recent-products'])
    : {}
theme.sections.register('recently-viewed', theme.RecentlyViewed)